import React from "react";
import { FluidViewer } from "@wuilt/fluid-engine/build/FluidViewer";
import useElements from "../hooks/useElements";

const FluidElement = ({ value, sectionId, pageContext }) => {
  const wuiltContext = useElements();
  return (
    <>
      <FluidViewer
        data={value}
        sectionId={sectionId}
        pageContext={pageContext}
        wuiltContext={wuiltContext}
      />
    </>
  );
};

export default FluidElement;
